import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/alarm_whitelists',
  component: Management,
  redirect: '/alarm_whitelists/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/alarm_whitelists/List'),
      meta: {
        auth: Auth.listAlarmWhitelists
      },
      redirect: 'list/all',
      children: [
        {
          path: 'all',
          component: () => import('@/views/alarm_whitelists/ListTable'),
          meta: {
            auth: Auth.listAlarmWhitelists,
            tabName: 'all'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/alarm_whitelists/New'),
      meta: {
        auth: Auth.createAlarmWhitelist
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/alarm_whitelists/Edit'),
      meta: {
        auth: Auth.updateAlarmWhitelist
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/alarm_whitelists/DetailLayout'),
      meta: {
        auth: Auth.showAlarmWhitelist
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/alarm_whitelists/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showAlarmWhitelist
          }
        }
      ]
    }
  ]
}
